import React, { useState } from "react";
import styled from "styled-components";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as TripLocalityPropertyActions from "../../store/actions/TripLocalityProperty";
import * as UserActions from "../../store/actions/User";
import NoFooterModal from "../../components/Common/NoFooterModal";
import {
  BottomSectionModal,
  NotesSection,
  UploadCsvOption,
} from "../../constants/assets/containers";
import FileUpload from "../../components/Common/FileUpload";
import InformationBar from "../../components/Common/InformationBar";
import variables from "../../constants/assets/variables";
import { useHistory } from "react-router";
import Errors from "../../constants/Errors.json";

const TripLocalityProperty = ({
  bulkUploadTripLocalityProperty,
  setStatus,
}) => {
  const history = useHistory();
  const [activeFile, setActiveFile] = useState("");
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const sample_download_url = `${
    process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL.replace(
          variables.routeEndpoint,
          variables.sampleFileEndPoint
        )}/sample/bulk_upload_trip_locality_properties.csv`
      : ""
  }`;

  const handleClose = () => {
    history.push("/");
  };

  const handleUpload = () => {
    const payload = { filename: activeFile.name.replace(".csv", "") };
    bulkUploadTripLocalityProperty(payload).then((res) => {
      if (res) {
        setCallback_key(res.callback_key);
        setPresign_url(res.file_upload_url);
      } else {
        setStatus({ type: "error", message: Errors.GENERAL_ERROR });
      }
    });
  };

  const instructions = [
    "Please provide Trip Locality Properties as per the format in the sample file.",
    "<b>property</b> and <b>locality_id</b> are <b>required</b> and <b>not</b> to be provided inside double quotes.",
    "<b>value</b> is required field and should strictly follow Property Validation Rules(if exists).",
    "Please refrain from putting anything else in columns other than the four <b>(locality_id, property, value,hour)</b>, as it may effect the processing of the file and can result in failures.",
  ];

  return (
    <TripLocalityPropertyBulkModal>
      <NoFooterModal
        header
        heading="Trip Locality Properties Bulk Upload"
        handleClose={handleClose}
        id="triplocalitybulkuploadModal"
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="assignCourse"
              disabled={activeFile === ""}
              onClick={handleUpload}
              className="sushi-btn"
            >
              Confirm
            </Button>
          </BottomSectionModal>
        }
      >
        <UploadCsvOption>
          <FileUpload
            title={"CSV File"}
            uploadUrl="/property/trip-locality/bulk/ack"
            callback_key={callback_key}
            presign_url={presign_url}
            handleClose={handleClose}
            keyName="callback_key"
            activeFile={activeFile}
            setActiveFile={setActiveFile}
            acceptTypes=".csv"
          />
        </UploadCsvOption>
        <NotesSection>
          <InformationBar
            sampleUrl={sample_download_url}
            instructions={instructions}
          />
        </NotesSection>
      </NoFooterModal>
    </TripLocalityPropertyBulkModal>
  );
};

const TripLocalityPropertyBulkModal = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    bulkUploadTripLocalityProperty: bindActionCreators(
      TripLocalityPropertyActions.bulkUploadTripLocalityProperty,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(TripLocalityProperty);
